export default "__VITE_ASSET__BvwKexPT__"